import React, { useState, useEffect, useRef } from "react";
import Close from "../../icons/Close";
import AddressFinderField from "../../utils/AddressFinderField";
import isAuSite from "../../../components/isAuSite";

const AddressPopup = (props) => {
  const [id, setId] = useState(props.address ? props.address.id : 0);
  const [company, setCompany] = useState(
    props.address ? props.address.company : ""
  );
  const [address, setAddress] = useState(
    props.address ? props.address.address : ""
  );
  const [address2, setAddress2] = useState(
    props.address ? props.address.address2 : ""
  );
  const [city, setCity] = useState(props.address ? props.address.city : "");
  // const [state, setState] = useState(props.address ? props.address.state : '');
  const [postcode, setPostcode] = useState(
    props.address ? props.address.postcode : ""
  );
  const [country, setCountry] = useState(
    props.address ? props.address.country : "NZ"
  );
  const [canEdit, setCanEdit] = useState(
    props.can_edit ? props.address.can_edit : true
  );

  const closePopup = () => {
    props.parent.closeAddressPopup();
  };

  const saveAddress = (e) => {
    e.preventDefault();
    props.parent.saveAddress({
      id: id,
      company: company,
      address: address,
      address2: address2,
      city: city,
      // state: state,
      postcode: postcode,
      country: country,
    });
    return false;
  };

  const selectAddress = (e) => {
    e.preventDefault();
    const selectedId = e.target.value;
    let selectedAddress = null;
    if (selectedId) {
      selectedAddress = props.parent.findAddressById(selectedId);
    }
    if (selectedAddress) {
      setId(selectedAddress.id);
      setCompany(selectedAddress.company);
      setAddress(selectedAddress.address);
      setAddress2(selectedAddress.address2);
      setCity(selectedAddress.city);
      // setState(selectedAddress.state);
      setPostcode(selectedAddress.postcode);
      setCountry(selectedAddress.country);
      setCanEdit(!selectedAddress.used_before);
    } else {
      setId(0);
      setCompany("");
      setAddress("");
      setAddress2("");
      setCity("");
      // setState('');
      setPostcode("");
      setCountry("");
      setCanEdit(true);
    }
    return false;
  };

  const setField = (e) => {
    const fieldName = e.target.getAttribute("name");
    const value = e.target.value;
    switch (fieldName) {
      case "company":
        setCompany(value);
        break;
      case "address":
        setAddress(value);
        break;
      case "address2":
        setAddress2(value);
        break;
      case "city":
        setCity(value);
        break;
      // case 'state':
      //     setState(value);
      //     break;
      case "postcode":
        setPostcode(value);
        break;
      case "country":
        setCountry(value);
        break;
      default:
        break;
    }
  };

  return (
    <div className="address-popup">
      <div className="container-">
        <div className="wrapper">
          <span className="address-popup__close" onClick={closePopup}>
            <Close />
          </span>
          <h3 className="h4 address-popup__title">Add new address</h3>
          <div className="address-popup__form">
            <form onSubmit={saveAddress}>
              <fieldset>
                {props.addresses && props.addresses.length > 0 && (
                  <div className="field select">
                    <label className="left">Select</label>
                    <select
                      className="dropdown"
                      value={id}
                      onChange={selectAddress}
                    >
                      <option value={0}>Saved addresses</option>
                      {props.addresses.map((address) => (
                        <option
                          key={`option__${address.id}`}
                          value={address.id}
                        >
                          {props.parent.getFullAddress(address)}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="field text">
                  <label className="left">Company</label>
                  <div className="middleColumn">
                    <input
                      type="text"
                      required={true}
                      name="company"
                      value={company}
                      readOnly={!canEdit}
                      className="text"
                      placeholder="Company name or person"
                      onChange={setField}
                    />
                  </div>
                </div>

                <div className="field text">
                  <label className="left">Address 1</label>
                  <div className="middleColumn">
                    <AddressFinderField
                      isAu={isAuSite()}
                      value={address}
                      onChanged={(v) => {
                        setAddress(address);
                      }}
                      onSelect={(address) => {
                        setAddress(`${address.unit_type ? address.unit_type : ''} ${address.unit_value ? address.unit_value : ''}${address.unit_type || address.unit_value ? ',': ''} ${address.street_number}${address.street_alpha ? address.street_alpha : ''} ${address.street} ${address.street_type}`);
                        setAddress2(address.suburb);
                        setCity(address.city);
                        setPostcode(address.postcode);
                        setCountry('NZ');
                      }}
                    />
                  </div>
                </div>

                <div className="field text">
                  <label className="left">Address 2</label>
                  <div className="middleColumn">
                    <input
                      type="text"
                      name="address2"
                      value={address2}
                      readOnly={!canEdit}
                      className="text"
                      placeholder="Address 2"
                      onChange={setField}
                    />
                  </div>
                </div>

                <div className="field text">
                  <label className="left">City</label>
                  <div className="middleColumn">
                    <input
                      type="text"
                      name="city"
                      required={true}
                      value={city}
                      readOnly={!canEdit}
                      className="text"
                      placeholder="City"
                      onChange={setField}
                    />
                  </div>
                </div>

                {/*<div className="field text">*/}
                {/*    <label className="left">State</label>*/}
                {/*    <div className="middleColumn">*/}
                {/*        <input*/}
                {/*            type="text"*/}
                {/*            required={true}*/}
                {/*            name="state"*/}
                {/*            value={state}*/}
                {/*            readOnly={!canEdit}*/}
                {/*            className="text"*/}
                {/*            placeholder="State"*/}
                {/*            onChange={setField}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className="field text">
                  <label className="left">Post Code</label>
                  <div className="middleColumn">
                    <input
                      type="text"
                      required={true}
                      name="postcode"
                      value={postcode}
                      readOnly={!canEdit}
                      className="text"
                      placeholder="Post Code"
                      onChange={setField}
                    />
                  </div>
                </div>

                <div className="field text">
                  <label className="left">Country</label>
                  <div className="middleColumn">
                    <select
                      name="country"
                      required={true}
                      value={country}
                      readOnly={!canEdit}
                      className="dropdown"
                      placeholder="Country"
                      onChange={setField}
                    >
                      {Object.keys(props.countries).map((key) => (
                        <option key={`country_${key}`} value={key}>
                          {props.countries[key]}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </fieldset>
              <div className="Actions">
                <input
                  type="Submit"
                  name="action_process"
                  value="Save"
                  className="action"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressPopup;
